const BASE = "/media";

const GET_MEDIA = `${BASE}/get-list-media`;
const CREATE_MEDIA = `${BASE}/create-media`;
const UPDATE_MEDIA = `${BASE}/update-media/{MEDIA_ID}`;
const REMOVE_MEDIA = `${BASE}/remove-media/{MEDIA_ID}`;

export const MEDIA_ROUTE = {
  GET_MEDIA,
  CREATE_MEDIA,
  UPDATE_MEDIA,
  REMOVE_MEDIA,
};
